import React, { ReactNode } from "react";
import { Col, Row } from "reactstrap";

interface BreadCrumbProps {
  title: string;
  /**
   * @deprecated Trail removido do produto — menu lateral basta (DOC 09).
   * Mantido opcional só para não quebrar demos Velzon / callsites antigos.
   */
  pageTitle?: string;
  /** Ações à direita (ex.: botão "Saiba mais"). */
  actions?: ReactNode;
}

/**
 * Cabeçalho de página do painel: só o título (+ ações opcionais).
 * Por quê sem breadcrumb: no layout Two Column o menu já localiza;
 * título + trilha na mesma linha virava uma frase ilegível e colidia com alertas.
 */
const BreadCrumb = ({ title, actions }: BreadCrumbProps) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">{title}</h4>
            {actions ? (
              <div className="page-title-right">{actions}</div>
            ) : null}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BreadCrumb;
